import React from 'react'
import cn from 'classnames'
import styles from './Banner.module.sass'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const Banner = () => {
  const { t } = useTranslation()

  return (
    <div className={cn('section', styles.banner)}>
      <div className={styles.content}>
        <div className={cn('h2', styles.title)}>
          {t('Earn Like Never Before!')}
        </div>
        <div className={styles.subTitle}>
          {t('Join the FiniticX Affiliate Program today and Gain up to')}
          <b> {t('50% commission')} </b>
          {t('on each referral')}
        </div>
        <button className={styles.button}>{t('Get started now')}</button>
      </div>
      <Link to="/" className={styles.logoLink}>
            <img
              src="/static/img/logo.png"
              alt="logo"
              // width={70}
              height={60}
            />
          </Link>
    </div>
  )
}

export default Banner
